import { render, staticRenderFns } from "./inviteView.vue?vue&type=template&id=5b16d6ec&scoped=true&"
import script from "./inviteView.vue?vue&type=script&lang=js&"
export * from "./inviteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16d6ec",
  null
  
)

export default component.exports